/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function DeviceMobilePortrait16(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'DeviceMobilePortrait16',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm3 9h2v1H7zm4-9H5v8h6z","fill":"currentColor"}),createElement('path', {"opacity":".6","fill":"currentColor","d":"M6 4h4v6H6z"}))
}
